export default __webpack_public_path__ + "static/media/generic_user.0f25815d.png";